import moment from 'moment';

export class FilterUtil {

  public percentage(perc?:string): string {
    return perc ? (parseFloat(perc) * 100).toFixed(2) + '%' : 'N/A';
  }

  public tsToString(ts:number|undefined, format:'full'|'no-seconds'|'am-pm' = 'full'): string {

    if(!ts)
      return 'N/A';
  
    switch(format) {
      case 'full': return moment(ts).format('DD/MM/YYYY, HH:mm:ss');
      case 'no-seconds': return moment(ts).format('DD/MM/YYYY, HH:mm');
      case 'am-pm': return moment(ts).format('L LT');
      default:
        return moment(ts).format(format);
    }
  }

  public maskPassword(pwd:string): string {
    return pwd.split('').map(ch => '*').join('');
  }
}